/*eslint-disable */
// import GPathCareertypeModel from '../../Model/GPathCareertype'
import request from '../../Utils/curl'
import Utility from "../../Utils/utility"

let GPathCareerType = {
  /**
   * gpath_career_roleList
   */
 async gpath_career_roleList (context, currentPage = '', filter = {}) {
  Utility.showLoader = true
  Utility.loadingMsg = "Please wait...."
  try {
    let post_data = new FormData();

    if (currentPage) {
      post_data.append('currentPage', currentPage);
    }

    if (Object.keys(filter).length > 0) {
      post_data.append('filter', JSON.stringify(filter));
    }

    return await request.curl(context, "gpath_career_type_list", post_data)
      .then(async response => {
        return response;
      });

  } 
  catch (err) {
    console.error('Exception occurred at gpath_career_type_List() and Exception:', err.message);
    throw err;
  }
  finally {
    Utility.showLoader = false
  }
},

  /**
   * gpath_career_role_view
   */
  async gpath_career_role_view (context, gpctId) {
    try {      
      let post_data = new FormData();
      post_data.append('gpct_id', gpctId);
      return await request.curl(context, "gpath_career_type_view", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at gpath_career_role_view() and Exception:",err.message)
    }    
  },

  /**
   * gpath_career_role_add
   */
  async gpath_career_role_add (context, gpath_career_typeObj) {
    try{
      let post_data = new FormData();
    
      for (let key in gpath_career_typeObj) {
        post_data.append(key, gpath_career_typeObj[key]);
      }

      return await request.curl(context, "gpath_career_type_add", post_data)
      .then(async response => {
          return response;
      });
    }
    catch(err){
      console.error('Exception occurred at gpath_career_type_add() and Exception:',err.message)
    }
  },

  /**
   * gpath_career_roleEdit
   */
  async gpath_career_roleEdit (context, gpath_career_typeObj) {
    try{
      let post_data = new FormData();
    
      for (let key in gpath_career_typeObj) {
        post_data.append(key, gpath_career_typeObj[key]);
      }

      return await request.curl(context, "gpath_career_type_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at gpath_career_type_Edit() and Exception:',err.message)
    }
  },

  /**
   * gpath_career_typeDelete
   */
  async gpath_career_typeDelete (context, gpathCareerTypeId) {
    try{
      let post_data = new FormData();
      
      post_data.append('gpct_id', gpathCareerTypeId);

      return await request.curl(context, "gpath_career_type_delete", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at gpath_career_typeDelete() and Exception:',err.message)
    }
  },

  /**
   * gpath_career_filter
   */
  async gpath_career_filter (context, filterName = "") {
    if (!filterName) {
      return
    }
    try {
      let postData = new FormData()
      postData.append("filter_name", filterName)

      return await request.curl(context, "gpath_careers_filter_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at gpath_careers_filter_list() and Exception:", err.message)
    }
  },
  /**
   * gpathCareerFollowedList
   */
  async gpathCareerFollowedList (context, currentPage='', filter = {}) {
    try{
      let post_data = new FormData();
      
      if (currentPage) {
        post_data.append('currentPage', currentPage)
      }

      if (Object.keys(filter).length > 0) {
        post_data.append('filter', JSON.stringify(filter))
      }
  
      return await request.curl(context, "gpath_career_list_followed", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at careerFollowedList() and Exception:',err.message)
    }
  },
}

export {
  GPathCareerType
}
